import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Course, CourseTest, EmployeeCourseAllocation } from 'src/app/shared/models/course';
import { Message } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';

@Component({
  selector: 'app-manageemployee-course-allocation',
  templateUrl: './manageemployee-course-allocation.component.html',
  styleUrls: ['./manageemployee-course-allocation.component.scss']
})
export class ManageemployeeCourseAllocationComponent implements OnInit {
  @Input() courseAllocation: EmployeeCourseAllocation;
  @Input() context: Context;
  public courseAllocationForm: FormGroup;
  private modified: boolean = false;
  public courses: Course[] = [];
  public courseTests: CourseTest[] = [];
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private datePipe: DatePipe,
    private authService: AuthService,
    private fb: FormBuilder,
    private courseService: CourseService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.courseService.getCourses().subscribe((courses) => (this.courses = courses));
    if (this.courseAllocation?.courseId) {
      this.fetchTimezoneByCourse(this.courseAllocation?.courseId)
    }
    this.context = this.authService.getContextData();
    this.setEmployeeCourseAllocation(this.courseAllocation);
  }

  public fetchTimezoneByCourse(courseId: number) {
    this.courseService.getCourseTests(courseId).subscribe((timezones) => (this.courseTests = timezones));
  }

  public setEmployeeCourseAllocation(courseAllocation?: EmployeeCourseAllocation) {
    if (!courseAllocation)
      courseAllocation = {
        id: null,
        startDate: '',
        endDate: '',
        disabled: false,
        employeeId: this.context.employeeId,
        employeeName: '',
        courseTestId: null,
        courseTestName: '',
        courseId: null,
        courseName: '',
      } as EmployeeCourseAllocation;
    this.courseAllocationForm = this.fb.group({
      id: this.fb.control(courseAllocation.id, null),
      startDate: this.fb.control(this.datePipe.transform(courseAllocation?.startDate || '', 'yyyy-MM-dd'), [Validators.required]),
      endDate: this.fb.control(this.datePipe.transform(courseAllocation?.endDate || '', 'yyyy-MM-dd'), [Validators.required]),
      employeeId: this.fb.control(courseAllocation?.employeeId,[Validators.required]),
      employeeName: this.fb.control(courseAllocation.employeeName),
      courseTestId: this.fb.control(courseAllocation.courseTestId,[Validators.required]),
      courseId: this.fb.control(courseAllocation.courseId,[Validators.required]),
      courseName: this.fb.control(courseAllocation.courseName),
      courseTestName: this.fb.control(courseAllocation.courseTestName, []),
      disabled: this.fb.control(courseAllocation.disabled, []),
    });

    this.courseAllocationForm.valueChanges.subscribe(value => this.modified = true);
  }

  get c() {
    return this.courseAllocationForm.controls;
  }

 
   public saveEmployeeCourseAllocation(inProgress?: any) {
     this.submitted = true;
     if (this.courseAllocationForm.valid) {
       const courseAllocation: EmployeeCourseAllocation = this.courseAllocationForm.value;
       if (!this.modified) {
         this.activeModal.close(false);
         this.commonService.setToastr(200, `CourseAllocation has been updated successfully!`);
         return;
       }
       inProgress.value = true;
       if (courseAllocation.id) {
         this.courseService.updateEmployeeCourseAllocation(courseAllocation.id, courseAllocation).subscribe({
           next: (response: Message) => {
             if (response) {
               this.activeModal.close(response);
               this.commonService.setToastr(200, response.text);
             } else {
               inProgress.value = false;
               this.commonService.setToastr(500, response.text);
             }
           },
           error: (error: HttpErrorResponse) => {
             inProgress.value = false;
             this.commonService.setToastr(500, error?.error?.name || error.error);
           },
         });
       } else {
         inProgress.value = false;
         this.courseService.createEmployeeCourseAllocation(courseAllocation).subscribe({
           next: (response: Message) => {
             if (response) {
               this.activeModal.close(response);
               this.commonService.setToastr(200, response.text);
             } else {
               inProgress.value = false;
               this.commonService.setToastr(500, response.text);
             }
           },
           error: (error: HttpErrorResponse) => {
             inProgress.value = false;
             this.commonService.setToastr(500, error?.error?.name || error.error);
           },
         });
       }
     }
   }
}
